import { createRoot } from 'react-dom/client';

const roots = new Map();

export const renderWithRoot = (component, container) => {
    let root = roots.get(container);
    if (!root) {
        root = createRoot(container);
        roots.set(container, root);
    }
    root.render(component);
};

export const unmountRootAtNode = (container) => {
    const root = roots.get(container);
    if (root) {
        root.unmount();
        roots.delete(container);
    }
    while (container.firstChild) {
        container.removeChild(container.firstChild);
    }
};
